import { Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Display navigation and content in horizontal layout
 * @category UI
 * @param props
 * @returns
 */
export function SubconfigurationNavigationHorizontal(props) {
    return (_jsxs(_Fragment, { children: [props.navigation, props.content] }));
}
//# sourceMappingURL=SubconfigurationNavigationHorizontal.js.map